import { ReactNode } from "react";

interface PageHeroProps {
  title: string;
  subtitle?: string;
  description?: string;
  children?: ReactNode;
  backgroundImage?: string;
  size?: "sm" | "md" | "lg";
}

export default function PageHero({
  title,
  subtitle,
  description,
  children,
  backgroundImage,
  size = "md",
}: PageHeroProps) {
  const heightClass = size === "lg" ? "h-[420px] md:h-[560px]" : size === "md" ? "h-[300px] md:h-[380px]" : "h-[220px] md:h-[280px]";

  return (
    <section
      className={`relative ${heightClass} flex items-center justify-center overflow-hidden bg-primary-800`}
    >
      {backgroundImage && (
        <>
          <img
            src={backgroundImage}
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-primary-900/75"></div>
        </>
      )}
      <div className="absolute inset-0 bg-gradient-to-b from-primary-900/20 to-primary-950/40"></div>

      <div className="relative z-10 container-page text-center">
        {subtitle && (
          <p className="text-accent-300 text-sm font-semibold uppercase tracking-wider mb-3">
            {subtitle}
          </p>
        )}
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-4">
          {title}
        </h1>
        {description && (
          <p className="text-lg md:text-xl text-foreground-300 max-w-3xl mx-auto leading-relaxed">
            {description}
          </p>
        )}
        {children}
      </div>
    </section>
  );
}